/**
 * @generated SignedSource<<1409c4b8ec5f78a9b4026aafde7a9f05>>
 * @relayHash 97e03929263e283448c77f083bb893f6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 97e03929263e283448c77f083bb893f6

import type { ConcreteRequest } from 'relay-runtime';
export type FirstTimeContributionBannerContributingGuidelinesQuery$variables = {
  name: string;
  owner: string;
};
export type FirstTimeContributionBannerContributingGuidelinesQuery$data = {
  readonly repository: {
    readonly contributingGuidelines: {
      readonly firstTimeContributionLink: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type FirstTimeContributionBannerContributingGuidelinesQuery = {
  response: FirstTimeContributionBannerContributingGuidelinesQuery$data;
  variables: FirstTimeContributionBannerContributingGuidelinesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v2 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ContributingGuidelines",
  "kind": "LinkedField",
  "name": "contributingGuidelines",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstTimeContributionLink",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FirstTimeContributionBannerContributingGuidelinesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FirstTimeContributionBannerContributingGuidelinesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "97e03929263e283448c77f083bb893f6",
    "metadata": {},
    "name": "FirstTimeContributionBannerContributingGuidelinesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7b6b2d24327dbcb2801c3c7962745aa7";

export default node;
